export class ProcedureModel {
    id: any = null;
    procedureName: string;
    description: string;
    included: string;
    isActive: boolean;
}